const typographyModalCloneCheckbox = {
  text: 'Clone Checklist',
  
};

export default typographyModalCloneCheckbox;
